(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartTrigger() {
    return (
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header--cart-toggle')
    );
  }

  function hasDrawerSections(response) {
    return !!(response && response.sections && response.sections['cart-drawer']);
  }

  function refreshCartBadge() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        mirailabUpdateCartBadge(cart);
        return cart;
      })
      .catch(function () {});
  }

  function fetchDrawerSections() {
    var url = window.location.pathname + '?sections=' + SECTIONS;
    return fetch(url).then(function (res) {
      return res.json();
    }).then(function (sections) {
      return { sections: sections };
    });
  }

  function showCartDrawer(response, triggerEl) {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    var trigger = triggerEl || getCartTrigger();
    if (trigger) cartDrawer.setActiveElement(trigger);

    if (typeof cartDrawer.renderContents === 'function' && hasDrawerSections(response)) {
      cartDrawer.renderContents(response);
      return;
    }

    if (response) {
      mirailabRefreshCartDrawer(response);
    }
    cartDrawer.open(trigger);
  }

  window.mirailabUpdateCartBadge = function (cart) {
    if (!cart) return;

    var count = cart.item_count;

    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = count;
    });

    document.querySelectorAll('.cart--external--total-items').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });

    document.querySelectorAll('.cart--external--icon').forEach(function (el) {
      el.setAttribute('data-item-count', count);
    });
  };

  window.mirailabRefreshCartDrawer = function (response) {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || !response || !response.sections || !response.sections['cart-drawer']) {
      return false;
    }

    var target = document.querySelector('#CartDrawer');
    var parsed = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
    var source = parsed.querySelector('#CartDrawer');

    if (target && source) {
      target.innerHTML = source.innerHTML;
    }

    var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        cartDrawer.close();
      });
    }

    var inner = cartDrawer.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }

    cartDrawer.classList.remove('is-empty');
    return true;
  };

  window.mirailabOpenCartDrawer = function (response, triggerEl) {
    showCartDrawer(response, triggerEl);

    if (!response || response.item_count == null) {
      return refreshCartBadge();
    }

    mirailabUpdateCartBadge(response);
    return Promise.resolve();
  };

  window.mirailabAfterCartAdd = function (response, triggerEl) {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return Promise.resolve();
    }

    var badgePromise =
      response && response.item_count != null
        ? (mirailabUpdateCartBadge(response), Promise.resolve())
        : refreshCartBadge();

    if (hasDrawerSections(response)) {
      showCartDrawer(response, triggerEl);
      return badgePromise;
    }

    return fetchDrawerSections().then(function (sectionResponse) {
      showCartDrawer(sectionResponse, triggerEl);
      return badgePromise;
    });
  };

  window.mirailabCartDrawerSections = SECTIONS;

  window.mirailabCartAddPayload = function (items) {
    return {
      items: items,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    };
  };
})();
